<template>
  <div>
    <el-container>
      <el-aside style="width: 200px;">
        <Menu activeName="3-3"></Menu>
      </el-aside>
      <el-main style="display: flex;flex: 1;padding: 0;flex-direction: row;height: 100vh;">
        <div
          style="position: fixed;left: 210px;top:2vh;z-index: 999;background-color: #ffffff;border-radius: 12px;height: 96vh;overflow:auto;">
          <div style="display: flex;flex-direction: column;width: 260px;padding: 20px;min-height: 100%;">
            <div style="display: flex;flex-direction: column;">
              <div>
                <div style="font-size: 14px;font-weight: 500;">多车规划参数</div>
                <span style="font-size: 12px;color: #999;margin-top: 4px;">车辆数量和车辆最大任务数中必须要填一项，如果都填写需要保证相乘后大于等于途径点数量，如果只填写其中一项，另一项会自动计算。</span>
              </div>
              <div style="display: flex;flex-direction: column;margin-top: 20px;">
                <div style="font-size: 14px;">车辆数量</div>
                <el-input-number style="margin-top: 10px;" :max="50" :min="0" v-model="routePlanReq.vehicle_number" label="车辆数量"></el-input-number>
              </div>
              <div style="display: flex;flex-direction: column;margin-top: 20px;">
                <div style="font-size: 14px;">单车最大任务数量</div>
                <el-input-number style="margin-top: 10px;" :max="100" :min="0" v-model="routePlanReq.vehicle_limit" label="单车最大任务数量"></el-input-number>
              </div>
            </div>
              <div class="setting">
                <div style="font-size: 14px;color: #606266;margin-bottom: 10px;">出行方式</div>
                <div style="display: flex;justify-content: space-between;">
                  <div :class="routePlanReq.mode === 1 ? 'mode-active' : 'mode'" @click="routePlanReq.mode = 1">
                    <img v-if="routePlanReq.mode === 1" src="/static/images/route/jiache-white.png" alt=""
                         style="width: 20px;height: 20px;">
                    <img v-else src="/static/images/route/jiache-blue.png" alt="" style="width: 20px;height: 20px;">
                    驾车
                  </div>
                  <div :class="routePlanReq.mode === 2 ? 'mode-active' : 'mode'" @click="routePlanReq.mode = 2">
                    <img v-if="routePlanReq.mode === 2" src="/static/images/route/qixing-white.png" alt=""
                         style="width: 20px;height: 20px;">
                    <img v-else src="/static/images/route/qixing-blue.png" alt="" style="width: 20px;height: 20px;">
                    骑行
                  </div>
                  <div :class="routePlanReq.mode === 3 ? 'mode-active' : 'mode'" @click="routePlanReq.mode = 3">
                    <img v-if="routePlanReq.mode === 3" src="/static/images/route/buxing-white.png" alt=""
                         style="width: 20px;height: 20px;">
                    <img v-else src="/static/images/route/buxing-blue.png" alt="" style="width: 20px;height: 20px;">
                    步行
                  </div>
                </div>
                <div style="font-size: 14px;margin-top: 20px;color: #606266;margin-bottom: 10px;">起点</div>
                <el-select v-model="originIndex" @change="originSelect" filterable
                           placeholder="选择起点位置"
                           :loading="origin_loading">
                  <el-option v-for="(item, index) in placeList" :key="index" :label="item.name" :value="index">
                  </el-option>
                </el-select>

                <div style="font-size: 14px;margin-top: 20px;color: #606266;margin-bottom: 10px;">途经点</div>
                <el-cascader @change="placeChangeHandle" v-model="placeIndexs" :options="waypointConf.options"
                             :props="waypointConf.props" collapse-tags filterable clearable>
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                  </template>
                </el-cascader>
              </div>
            <div>
              <div style="display: flex;flex-direction: column;">
                <div style="font-size: 14px;margin-top: 20px;">终点</div>
                <div style="margin-top: 10px;display: flex;">
                  <img :src="route[0]" alt="" @click="chooseRouteType(0)">
                  <img :src="route[1]" alt="" @click="chooseRouteType(1)" style="margin-left: 20px;">
                </div>
              </div>
              <div style="display: flex;flex-direction: column;">
                <div style="font-size: 14px;margin-top: 20px;">选择策略</div>
                <div style="display: flex;flex-direction: row;justify-content: space-between;margin-top: 10px;">
                  <el-radio style="margin: 0;" v-model="routePlanReq.strategy" :label=1 size="small" border>路程短
                  </el-radio>
                  <el-radio style="margin: 0;" v-model="routePlanReq.strategy" :label=2 size="small" border>时间短
                  </el-radio>
                  <el-radio style="margin: 0;" v-model="routePlanReq.strategy" :label=3 size="small" border>顺路
                  </el-radio>
                </div>
              </div>
            </div>
            <div style="margin-top: 80px;">
              <el-button @click="routePlanning" type="primary" v-loading="routePlanLoading"
                         style="width: 260px;height: 40px;">开始规划
              </el-button>
            </div>
          </div>
        </div>
        <div class="map" style="flex: 1;height: 100vh;">
          <el-amap vid="map" @init="initMap" style="flex: 1;">
            <el-amap-control-geolocation :visible="true"></el-amap-control-geolocation>

            <template v-if="placeMarkers.length > 0">
              <el-amap-marker :zIndex="98" v-for="(item, index) in placeMarkers" :key="'place-' + index"
                              :vid="item.location" anchor="center"
                              :position="[item.locations.longitude, item.locations.latitude]"
                              @mouseover="handleMouseOver(item.id)" @mouseout="handleMouseLeave">
                <div style="display: flex;flex-direction: column;align-items: center;">
                  <div class="route-place-name">{{ item.name }}</div>
                  <div class="route-place-sort">途</div>
                </div>
              </el-amap-marker>
            </template>

            <template v-if="originMarker.name">
              <el-amap-marker :zIndex="98" anchor="center" :position="originMarker.location">
                <div style="display: flex;flex-direction: column;align-items: center;">
                  <div class="route-origin-name">{{ originMarker.name }}</div>
                  <div class="route-origin-text">起</div>
                </div>
              </el-amap-marker>
            </template>


            <el-amap-info-window v-if="placeMarkers.length > 0" v-for="(item, index) in placeMarkers"
                                 :key="'place-window-' + index" :closeWhenClickMap="true"
                                 :position="[item.locations.longitude, item.locations.latitude]" :autoMove="false"
                                 :offset="[0, -20]"
                                 anchor="bottom-center" :visible="item.id == mapConf.overPlaceId">
              <div style="display: flex;flex-direction: column;padding:4px;margin-top: 4px;">
                <div style="font-size: 16px;color: #333;font-weight: 500">{{ item.name }}</div>
                <div style="font-size: 14px;color: #666;margin-top: 4px;">{{ item.address }}</div>
                <div style="font-size: 14px;color: #666;">客户：{{ item.phone_name }} 电话：{{ item.phone }}</div>
              </div>
            </el-amap-info-window>
          </el-amap>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue'
import {GetRoutePlanNeedPlace, GetAllTeamPlaceList, SearchAddress} from '../api/place.js'
import {GetRouteDetails, GetRoutePlace, MultiVehicleRoutePlanner} from '../api/route.js'
import store from 'store'

export default {
  name: 'Plan',
  components: {Menu},
  data () {
    return {
      routePlanLoading:false,
      originIndex: '',
      origin_keyword: '', // 起点搜索关键字
      details: {},
      placeList: [], // 团队所有地点列表
      endList: [], // 当前途经点生成的终点列表
      origin_loading: false, // 起点搜索加载状态
      originList: [], // 起点列表
      originMarker: {}, // 起点marker
      routePlanReq: { // 路线规划请求参数
        mode: 1,
        strategy: 1,
        route_type: 1,
        vehicle_number:0,
        vehicle_limit:0
      },
      waypointConf: {
        props: {multiple: true},
        options: []
      },
      placeIndexs: [],
      placeMarkers: [],
      mapConf: {
        center: [],
        zooms: [3, 19],
        mapStyle: 'normal',
        overPlaceId: 0
      },
      hoverTimer: {},
      route: [
        '/static/images/route/route-set/0-select.png',
        '/static/images/route/route-set/1.png',
        '/static/images/route/route-set/2.png',
      ],
      route_not_select: [
        '/static/images/route/route-set/0.png',
        '/static/images/route/route-set/1.png',
        '/static/images/route/route-set/2.png',
      ],
      route_select: [
        '/static/images/route/route-set/0-select.png',
        '/static/images/route/route-set/1-select.png',
        '/static/images/route/route-set/2-select.png',
      ],
    }
  },
  mounted () {
    this.reload()
  },
  methods: {
    initMap (e) {
      this.map = e
    },
    reload () {
      this.getTeamPlaceList()
    },
    handleMouseOver (id) {
      console.log(id)
      let that = this
      clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(function () {
        that.mapConf.overPlaceId = id
      }, 500)
    },
    handleMouseLeave () {
      this.mapConf.overPlaceId = 0
      clearTimeout(this.hoverTimer)
      this.$forceUpdate()
    },
    originSelect (index) {
      let info = this.placeList[index]
      this.routePlanReq.origin_name = info.name
      this.routePlanReq.origin_location = info.location
      this.formatOriginMarker()
    },
    formatOriginMarker () {
      let req = this.routePlanReq
      let name = req.origin_name
      let location = req.origin_location.split(',')
      this.originMarker = {
        name: name,
        location: location,
      }
      this.map.setCenter(new AMap.LngLat(location[0], location[1]))
      this.map.setZoom(17)
    },
    getTeamPlaceList () {
      GetAllTeamPlaceList().then(res => {
        if (res.code === 200) {
          this.placeList = res.data.list
          this.$forceUpdate()
          if (this.$route.query.id) {
            this.copyRouteDetails()
          }
          this.getPlaceSelectOptions()
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
    getPlaceSelectOptions () {
      let that = this
      GetRoutePlanNeedPlace().then(res => {
        if (res.code === 200) {
          that.waypointConf.options = res.data.list
        } else {
          that.$notify({
            title: '错误',
            type: 'error',
            message: res.message
          })
        }
      })
    },
    chooseRouteType (index) {
      this.routePlanReq.route_type = index + 1
      if (index !== 2) {
        this.routePlanReq.end_location = ''
      }
      this.refreshRouteType(index + 1)
    },
    // 刷新终点策略
    refreshRouteType (route_type) {
      let index = route_type - 1
      this.route[index] = this.route_select[index]
      for (let i = 0; i < 3; i++) {
        if (i !== index) {
          this.route[i] = this.route_not_select[i]
        }
      }
      this.$forceUpdate()
    },
    // 刷新途经点选项
    refreshWayPlace (locationArr) {
      let list = this.placeList
      let index = []
      let idArr = []
      for (let i = 0; i < list.length; i++) {
        let val = list[i]
        if (locationArr.includes(val.location)) {
          if (val.district === '') {
            val.district = '其它'
          }
          index.push([val.district, val.id])
          idArr.push(val.id)
        }
      }
      this.routePlanReq.place_ids = idArr.join(',')
      this.placeIndexs = index
      this.formatPlaceMarkers()
      this.$forceUpdate()
    },
    formatPlaceMarkers () {
      let list = this.placeList
      let ids = this.formatPlaceIndex()
      let markers = []
      for (let i = 0; i < list.length; i++) {
        let val = list[i]
        if (ids.includes(val.id)) {
          markers.push(val)
        }
      }
      this.placeMarkers = markers
    },
    formatPlaceIndex () {
      let ids = []
      let index = this.placeIndexs
      for (let i = 0; i < index.length; i++) {
        ids[i] = index[i][1]
      }
      return ids
    },
    placeChangeHandle () {
      let that = this
      let list = this.placeList
      let ids = this.formatPlaceIndex()
      let markers = []
      for (let i = 0; i < list.length; i++) {
        let val = list[i]
        if (ids.includes(val.id)) {
          markers.push(val)
        }
      }
      this.placeMarkers = markers
      this.routePlanReq.place_ids = ids.join(',')
    },
    // 复制路线-回填
    copyRouteDetails () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let that = this
      GetRouteDetails({id: this.$route.query.id}).then(res => {
        if (res.code === 200) {
          let info = res.data.info
          this.routePlanReq.name = info.name
          this.routePlanReq.mode = info.mode
          this.routePlanReq.route_type = info.route_type
          this.routePlanReq.strategy = info.strategy
          this.routePlanReq.origin_name = info.origin_name
          this.routePlanReq.origin_location = info.origin_location
          this.routePlanReq.end_id = info.end_id
          this.originList = [{name: info.origin_name, location: info.origin_location}]
          this.originIndex = 0
          this.formatOriginMarker()
          this.getRoutePlaceList(this.$route.query.id)
          this.refreshRouteType(info.route_type)
        }
      })
      setTimeout(function () {
        loading.close()
      }, 3000)
    },
    getRoutePlaceList (id) {
      let that = this
      GetRoutePlace({route_id: id}).then(res => {
        if (res.code === 200) {
          let locationArr = []
          for (let i = 0; i < res.data.list.length; i++) {
            if (res.data.list[i].id === this.routePlanReq.end_id) {
              this.routePlanReq.end_location = res.data.list[i].location
            }
            locationArr.push(res.data.list[i].location)
          }
          this.refreshWayPlace(locationArr)
        }
      })
    },
    routePlanning () {
      let that = this
      let ids = this.routePlanReq.place_ids.split(',')
      if (this.routePlanReq.vehicle_number >0 && this.routePlanReq.vehicle_limit>0 && this.routePlanReq.vehicle_number*this.routePlanReq.vehicle_limit < ids.length) {
        this.$notify({
          type: 'warning',
          message: "车辆数量和最大任务数量异常"
        })
        return false;
      }
      this.routePlanLoading = true
      MultiVehicleRoutePlanner(this.routePlanReq).then(res => {
        this.routePlanLoading = false
        if (res.code === 200) {
          this.$notify({
            type: 'success',
            message: '多车规划路线成功',
            duration: 1000,
            onClose () {
              that.$router.push({name: 'route-list'})
            }
          })
        } else {
          this.$notify({
            type: 'error',
            message: res.message
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.setting {
  display: flex;
  flex-direction: column;
  background-color: #e8eaec;
  padding: 20px 10px;
  border-radius: 10px;
  margin-top: 20px;
}

.setting .mode {
  padding: 2px 13px;
  background-color: #fff;
  color: #2d8cf0;
  border-radius: 5px;
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: default;
}

.setting .mode-active {
  padding: 3px 13px;
  border-radius: 5px;
  font-weight: bold;
  height: 30px;
  line-height: 30px;
  display: flex;
  align-items: center;
  font-size: 12px;
  background-color: #2d8cf0;
  color: #fff;
  cursor: default;
}

.number-details {
  width: 96%;
  margin: 20px auto;
  height: 150px;
  box-shadow: 0 0 10px 0 rgb(42 60 89/16%);
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.number-details .number-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.number-item .number-num {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}

.number-item .number-label {
  font-size: 12px;
  color: #808695;
  margin-top: 2px;
}

.route-place-name {
  font-size: 12px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #2979ff;
  white-space: nowrap;
  padding: 2px 4px;
  z-index: 98;
  margin-bottom: 4px;
}

.route-origin-name {
  font-size: 12px;
  color: #333;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #19be6b;
  white-space: nowrap;
  padding: 2px 4px;
  z-index: 98;
  margin-bottom: 4px;
}

.route-origin-text {
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border: 2px solid #fff;
  background-color: #19be6b;
  z-index: 99;
}

.route-place-sort {
  font-size: 12px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  text-align: center;
  line-height: 20px;
  color: #fff;
  border: 2px solid #fff;
  background-color: #2979ff;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/views/MultiVehiclePlan.vue